module.exports = __webpack_public_path__ + "img/icon1.ddf5a7f7.svg";